
import { DefectModel } from '@/libs/Api';
import Page from '@/Page.vue';
import { Component, Ref } from 'vue-property-decorator';
import { defectsStore } from '@/libs/defects/+state/store';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import DefectDialog from './DefectDialog.vue';
import { Guid } from '@/libs/common/functions/guid';

@Component({
    components: { DefectDialog },
})
export default class DefectSelectDialog extends Page {
    dialog = false;
    search = '';
    selectedDefects: DefectModel[] = [];
    
    @Ref() defectDialog!: any;

    headers = [
        { text: this.$i18n.t('defects.code'), value: 'code', align: 'left', sortable: true },
        { text: this.$i18n.t('defects.name'), value: 'name', align: 'left', sortable: true },
    ];

    get allDefects(): DefectModel[] {
        const defects = (defectsStore.useGetter(CrudGetter.Data) as DefectModel[]) ?? [];
        return defects.sort((a, b) => (a.code ?? '').localeCompare(b.code ?? ''));
    }

    open(preselectedIds: string[] = []) {
        this.dialog = true;
        this.search = '';
        this.selectedDefects = this.allDefects.filter(d => preselectedIds.includes(d.id!));
    }

    close() {
        this.dialog = false;
        this.selectedDefects = [];
        this.search = '';
    }

    confirmSelection() {
        this.$emit('selected', this.selectedDefects);
        this.close();
    }

    createNew() {
        this.defectDialog.open(Guid.EmptyGuid());
    }

    onDefectCreated(defect: DefectModel) {
        // Automaticky přidat nově vytvořenou poruchu do výběru
        if (defect && defect.id && !this.selectedDefects.find(x => x.id === defect.id)) {
            this.selectedDefects.push(defect);
        }
    }
}
